import { CalendarX, CheckCircle2, ClipboardList, Users } from 'lucide-react'
import { StatsCard } from '../../../../components'
import type { AttendanceSummary } from '../types/hrmsAttendanceLeave.types'

interface AttendanceStatsRowProps {
  summary: AttendanceSummary
}

export function AttendanceStatsRow({ summary }: AttendanceStatsRowProps) {
  const presentPct =
    summary.totalStaff > 0
      ? (Math.round((summary.presentToday / summary.totalStaff) * 1000) / 10).toFixed(1)
      : '0.0'

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 min-w-0">
      <StatsCard className="w-full min-w-0">
        <div className="flex items-start justify-between gap-2">
          <span className="text-[12px] font-bold uppercase text-[#65748b] tracking-wider block truncate">
            TOTAL STAFF
          </span>
          <span className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-slate-100 text-slate-700">
            <Users className="h-5 w-5" />
          </span>
        </div>
        <div className="mt-2 flex items-baseline gap-2 flex-wrap min-w-0">
          <span className="text-[28px] font-bold leading-none text-[#1f2937]">
            {summary.totalStaff}
          </span>
          <span className="text-[13px] text-[#5d6a7a] font-medium truncate">
            Active academic & support
          </span>
        </div>
      </StatsCard>

      <StatsCard className="w-full min-w-0">
        <div className="flex items-start justify-between gap-2">
          <span className="text-[12px] font-bold uppercase text-[#65748b] tracking-wider block truncate">
            PRESENT TODAY
          </span>
          <span className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-emerald-50 text-emerald-600">
            <CheckCircle2 className="h-5 w-5" />
          </span>
        </div>
        <div className="mt-2 flex items-baseline gap-2 flex-wrap min-w-0">
          <span className="text-[28px] font-bold leading-none text-[#1f2937]">
            {summary.presentToday}
          </span>
          <span className="text-[13px] text-[#5d6a7a] font-medium truncate">
            {presentPct}% of total faculty
          </span>
        </div>
      </StatsCard>

      <StatsCard className="w-full min-w-0">
        <div className="flex items-start justify-between gap-2">
          <span className="text-[12px] font-bold uppercase text-[#65748b] tracking-wider block truncate">
            ON LEAVE TODAY
          </span>
          <span className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-amber-50 text-amber-600">
            <CalendarX className="h-5 w-5" />
          </span>
        </div>
        <div className="mt-2 flex items-baseline gap-2 flex-wrap min-w-0">
          <span className="text-[28px] font-bold leading-none text-[#1f2937]">
            {summary.onLeaveToday}
          </span>
          <span className="text-[13px] text-[#5d6a7a] font-medium truncate">
            Across all departments
          </span>
        </div>
      </StatsCard>

      <StatsCard className="w-full min-w-0">
        <div className="flex items-start justify-between gap-2">
          <span className="text-[12px] font-bold uppercase text-[#65748b] tracking-wider block truncate">
            PENDING REQUESTS
          </span>
          <span className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-rose-50 text-rose-600">
            <ClipboardList className="h-5 w-5" />
          </span>
        </div>
        <div className="mt-2 flex items-baseline gap-2 flex-wrap min-w-0">
          <span className="text-[28px] font-bold leading-none text-[#1f2937]">
            {summary.pendingRequests}
          </span>
          <span className="text-[13px] text-[#5d6a7a] font-medium truncate">
            Requires action
          </span>
        </div>
      </StatsCard>
    </div>
  )
}
